import React, { useEffect, useState } from "react";
import { Pagination, PaginationItem, PaginationLink, Badge } from "reactstrap";

import { Button, Table } from "reactstrap";

import { assetWithdrawHistory } from "store/actions";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { Container } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import ViewMoreModel from "./viewMore-model";
import useToastr from "helpers/toastr";
import ButtonLoader from "Component/Common/ButtonLoader";
import { FaCaretDown, FaCaretUp } from "react-icons/fa";
import { useTranslation } from 'react-i18next';

const History = () => {
  const itemsPerPage = 1;
  const navigate = useNavigate();
  const toastr = useToastr();
  const { t } = useTranslation();

  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setshowModal] = useState(false);

  const [selectedItem, setSelectedItem] = useState();

  const { assetListing, assetTotal, loading } = useSelector(({ Wallet }) => Wallet);
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state?.Login);

  const [filter, setFilter] = useState({
    orderBy: "createdAt",
    order: -1,
    page: 1,
    pageSize: 10,
    id: user?._id,
  });

  const [historyList, setHistoryList] = useState([]);

    /**
     * Used for calling api of assets history
     */
  useEffect(() => {
    dispatch(assetWithdrawHistory({ ...filter }));
  }, [filter]);

  useEffect(() => {
    if (assetListing?.length > 0) {
      setHistoryList(assetListing);
    }
  }, [assetListing]);

  // eslint-disable-next-line no-unused-vars

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const totalPages = Math.ceil(assetTotal / filter?.pageSize);

  const handleClick = (page) => {
    dispatch(assetWithdrawHistory({ ...filter, page: page }));

    setCurrentPage(page);
  };

    /**
     * Used for change the page number dynamically
     */
  const renderPagination = () => {
    const paginationItems = [];

    for (let i = 1; i <= totalPages; i++) {
      paginationItems.push(
        <PaginationItem key={i} active={i === currentPage}>
          <PaginationLink onClick={() => handleClick(i)}>{i}</PaginationLink>
        </PaginationItem>
      );
    }

    return paginationItems;
  };

  const handleBack = () => {
    navigate(-1);
  };

  const handleViewInfo = (obj) => {
    setshowModal(true);
    setSelectedItem(obj);
  };
  const filterChangeHandler = (col, val) => {
    const order = val === -1 ? 1 : -1;
    setFilter((prevState) => {
      return { ...prevState, page: 1, orderBy: col, order: order };
    });
  };

    /**
     * Used for render the UI of history listing
     */
  return (
    <React.Fragment>
      
        <ViewMoreModel
          show={showModal}
          onHide={() => setshowModal(!showModal)}
          selectedItem={selectedItem}
        />
      
      <section className="history_page home_banner_main sellpagetwo position-relative">
        <div className="top_circle"></div>
        <Container>
          <div className="d-flex align-items-center">
            <Link to="" onClick={handleBack} className="arrow_back me-3">
              <svg
                role="button"
                width="25"
                height="25"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 10"
              >
                <path
                  stroke="#000"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1"
                  d="M13 5H1m0 0 4 4M1 5l4-4"
                />
              </svg>
            </Link>

            <h4 className="text-start m-0">{t('transaction_history')}</h4>
          </div>

          <div className="history_table mt-4">
            {loading && <ButtonLoader />}
            <div className="table-responsive">
              {!loading && (
                <table className="table table-nowrap">
                  <thead>
                    <th>{t('asset_id')}</th>
                    <th>{t('amount')}</th>
                    <th>{t('transaction_type')}</th>
                    <th>{t('status')}</th>
                    {historyList.length > 0 && (
                      <th
                        onClick={(e) =>
                          filterChangeHandler("createdAt", filter.order)
                        }
                      >
                        {t('created_at')}{" "}
                        {filter.order === 1 ? (
                          <FaCaretUp className="icon-class" />
                        ) : (
                          <FaCaretDown className="icon-class" />
                        )}{" "}
                      </th>
                    )}
                    {historyList.length === 0 && <th>{t('created_at')} </th>}
                    <th></th>
                  </thead>
                  <tbody>
                    {historyList.length > 0 &&
                      historyList.map((item, idx) => (
                        <tr key={idx}>
                          <td>{item.assetId}</td>
                          <td>
                            {item?.amountInfo?.amount
                              ? item?.amountInfo?.amount
                              : "--"}
                          </td>
                          <td>
                            {item.transactionType == "withdrawal"
                              ? t('withdrawal')
                              : t('deposit')}
                          </td>

                          <td>
                            <Badge className="forbadge" color={item.status.toUpperCase() == "COMPLETED" ? "success" :
                              item.status.toUpperCase() == "NEW" ? "primary" : item.status.toUpperCase() == "FAILED" ? "danger" 
                              :item.status.toUpperCase() == "SUBMITTED" ? "info" 
                              :item.status.toUpperCase() == "CONFIRMING" ? "secondary" 

                              : "warning"
                            }> {item.status} </Badge>

                          </td>                          <td>
                            {moment(item.createdAt).format(
                              "DD MMM YYYY - hh:mm A"
                            )}
                          </td>
                          <td>
                            <Button
                              onClick={() => handleViewInfo(item)}
                              className="table_eye"
                            >
                              <span>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="26"
                                  height="26"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    fill="#ccc"
                                    d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5s5 2.24 5 5s-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3s3-1.34 3-3s-1.34-3-3-3z"
                                  />
                                </svg>
                              </span>
                            </Button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              )}

              {!loading && historyList.length > 0 && (
                <div className="d-flex align-items-center justify-content-end mt-5 me-3">
                  <Pagination aria-label="Page navigation example">
                    <PaginationItem disabled={currentPage === 1}>
                      <PaginationLink
                        previous
                        onClick={() => handleClick(currentPage - 1)}
                      />
                    </PaginationItem>

                    {renderPagination()}

                    <PaginationItem disabled={currentPage === totalPages}>
                      <PaginationLink
                        next
                        onClick={() => handleClick(currentPage + 1)}
                      />
                    </PaginationItem>
                  </Pagination>
                </div>
              )}
              {!loading && historyList.length === 0 && (
                <p>{t('no_transactions')}</p>
              )}
            </div>
          </div>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default History;
